// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1_7LU","head":"ProcedureTableInfo_head__1B_ge"};